import React, {useContext} from 'react';
import styles from './PictureTextFlexRow1.module.css'
import {Link} from 'react-router-dom';

const PictureTextFlexRow1=(props)=>{

    const title = props.title;
    const text = props.text;
    const image_src = props.image_src;
    const image_alt = props.image_alt;

    const image_caption = props.image_caption;

    return (
        <div className={styles.layout}>
            <div className={styles.left}>
                <div className={styles.left_content}>
                    
                     {/* TITLE */}
                    <span className={styles.title}><b>{title}</b></span>
                    
                    {/* BODY TEXT */}
                    <div className={styles.left_content_text} dangerouslySetInnerHTML={{ __html: text }}></div>

                </div>                
            </div>

            <div className={styles.right}> 

                {/* IMAGE */}
                <img src={image_src} alt={image_alt}/>
                
                {/* CAPTION */}
                <div>{image_caption}</div>
                
            </div>    
            
            <div><span></span></div>

        </div>
    )
};

export default PictureTextFlexRow1;
